import { useState } from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { isAuthenticated, addGrade } from "../../../ApiService/ApiService";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import CustomDialog from "../../../Components/CustomDialog";

function AddGrade({ fetchGrades, setShowAddGrade }) {
  const [formData, setFormData] = useState({
    name: "",
  });
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!formData.name) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please fill all the details",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
      return;
    }

    try {
      if (isAuthenticated()) {
        const response = await addGrade(formData);
        // console.log("RES", response);
        if (response) {
          if (response?.data?.status === 200) {
            setDialog({
              visible: true,
              title: "Success",
              message: "Grade added",
              buttons: [{ name: "OK", onPress: handleDialogClose }],
            });
            setFormData({ name: "" });
            fetchGrades();
            setShowAddGrade(false);
          } else {
            const errorMessage =
              response?.data?.errorMessage || "Something went wrong";
            setDialog({
              visible: true,
              title: "Error",
              message: errorMessage,
              buttons: [{ name: "Close", onPress: handleDialogClose }],
            });
          }
        } else {
          setDialog({
            visible: true,
            title: "Error",
            message: "Invalid response from the server",
            buttons: [{ name: "Close", onPress: handleDialogClose }],
          });
        }
      } else {
        setDialog({
          visible: true,
          title: "Unauthorized action",
          message: "Please login and try again",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
      }
    } catch (error) {
      console.error("Failed to add grade", error);
      setDialog({
        visible: true,
        title: "Error",
        message: "Failed to add grade",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Box sx={{ maxWidth: "75%", margin: "auto", padding: 3 }}>
        <Paper elevation={3} sx={{ padding: 5 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, fontSize: 22, color: "black" }}
          >
            Add Grade
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {" "}
                <Button
                  fullWidth
                  variant="contained"
                  color="inherit"
                  onClick={() => setShowAddGrade(false)}
                  startIcon={<ArrowBack />}
                  sx={{ textTransform: "unset" }}
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {" "}
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  endIcon={<ArrowForward />}
                  sx={{ textTransform: "unset" }}
                >
                  {loading ? "Loading..." : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
}

export default AddGrade;
